import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'signin-use_password_to_link_sso-action_unknown';

/**
 * Fires whenever a user with an existing email and password account clicks on an SSO button to link it, and are asked for their password to do so.
 */
export function trackSigninUsePasswordToLinkSso(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
  });
}
